
enum L2ControlGridLayout {
	FlexColumn = 'flexColumn',
	FlexRow = 'flexRow',
	FlowRow = 'flowRow',
	FlowColumn = 'flowColumn',
	EqualDividedRow = 'equalDividedRow',
	EqualDividedColumn = 'equalDividedColumn',
	GoldenShortLongRow = 'goldenShortLongRow',
	DecoratedRow = 'decoratedRow',
}

export default L2ControlGridLayout
